//SERVICES
import ServiceUser from "../../services/User";

//COOKIE
import Cookies from "js-cookie";

//TYPES
export const START_LOGGED = "START_LOGGED";
export const IS_LOGGED = "  IS_LOGGED";
export const ERROR_LOGGED = "  ERROR_LOGGED";
export const START_LOGOUT = "START_LOGOUT";
export const IS_LOGOUT = "  IS_LOGOUT";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "  END_LOADING";
export const ERROR_LOGOUT = "  ERROR_LOGOUT";
export const START_REGISTER = "START_REGISTER";
export const IS_REGISTER = "  IS_REGISTER";
export const ERROR_REGISTER = "  ERROR_REGISTER";
export const START_RESTORE_PASSWORD = "START_RESTORE_PASSWORD";
export const IS_RESTORE_PASSWORD = "  IS_RESTORE_PASSWORD";
export const ERROR_RESTORE_PASSWORD = "  ERROR_RESTORE_PASSWORD";
export const START_RESEND_CONFIRMATION = "START_RESEND_CONFIRMATION";
export const IS_RESEND_CONFIRMATION = "  IS_RESEND_CONFIRMATION";
export const ERROR_RESEND_CONFIRMATION = "  ERROR_RESEND_CONFIRMATION";
export const START_CHECK = "START_CHECK";
export const IS_CHECK = "  IS_CHECK";
export const ERROR_CHECK = "  ERROR_RESTORE_PASSWORD";
export const START_MODIFIED_USER = "START_MODIFIED_USER";
export const IS_MODIFIED_USER = "  IS_MODIFIED_USER";
export const IS_MODIFIED_POINTS_USER = "  IS_MODIFIED_POINTS_USER";
export const ERROR_MODIFIED_USER = "  ERROR_MODIFIED_USER";
export const START_CARD_USER = "START_CARD_USER";
export const IS_CARD_USER = "  IS_CARD_USER";
export const ERROR_CARD_USER = "  ERROR_CARD_USER";

export const IS_IN_SESSION = "  IS_IN_SESSION";
export const ISNT_IN_SESSION = "  ISNT_IN_SESSION";

export function loginAction(email, password) {
  return async dispatch => {
    dispatch({ type: START_LOGGED });

    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.login(email, password)
        .then(user => {
          dispatch({
            type: IS_LOGGED,
            payload: user
          });
          resolve();
        })
        .catch(error => {
          dispatch({ type: ERROR_LOGGED });
          reject(error.response);
        });
    });
  };
}

export function restorePasswordAction(email) {
  return async dispatch => {
    dispatch({ type: START_RESTORE_PASSWORD });

    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.restorePassword(email)
        .then(r => {
          dispatch({
            type: IS_RESTORE_PASSWORD
          });
          resolve(r);
        })
        .catch(error => {
          dispatch({ type: ERROR_RESTORE_PASSWORD });
          reject(error.response);
        });
    });
  };
}
export function resendConfirmationMailAction(email) {
  return async dispatch => {
    dispatch({ type: START_RESEND_CONFIRMATION });

    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.resendConfirmationMail(email)
        .then(r => {
          dispatch({
            type: IS_RESEND_CONFIRMATION
          });
          resolve();
        })
        .catch(error => {
          dispatch({ type: ERROR_RESEND_CONFIRMATION });
          reject(error.response);
        });
    });
  };
}

export function changeUserAction(userId, user, changePassword, changeEmail) {
  return async dispatch => {
    dispatch({ type: START_MODIFIED_USER });

    return new Promise((resolve, reject) => {
      ServiceUser.INSTANCE.changeUser(userId, user, changePassword, changeEmail)
        .then(user => {
          dispatch({
            type: IS_MODIFIED_USER,
            payload: user
          });
          resolve();
        })
        .catch(error => {
          dispatch({ type: ERROR_MODIFIED_USER });
          reject(error.response);
        });
    });
  };
}

export function setPointsAction(userId) {
  return async dispatch => {
    //dispatch({ type: START_MODIFIED_USER });

    ServiceUser.INSTANCE.getPoints(userId)
      .then(points => {
        dispatch({
          type: IS_MODIFIED_POINTS_USER,
          payload: points
        });
      })
      .catch(error => {
        dispatch({ type: ERROR_MODIFIED_USER });
      });
  };
}

export function setUserAction(user) {
  return async dispatch => {
    dispatch({ type: START_MODIFIED_USER });

    dispatch({
      type: IS_MODIFIED_USER,
      payload: user
    });
  };
}

export function logoutAction() {
  return async dispatch => {
    dispatch({ type: START_LOGOUT });

    return new Promise((resolve, reject) => {
      Cookies.remove("iluToken");
      dispatch({
        type: IS_LOGOUT
      });
      resolve();
    });
  };
}

export function loadingAction(loading) {
  return async dispatch => {
    if (loading) {
      dispatch({ type: START_LOADING });
    } else {
      dispatch({
        type: END_LOADING,
        payload: loading
      });
    }
  };
}

export function checkIsSessionAction() {
  return async dispatch => {
    const token = Cookies.get("iluToken");
    const user = Cookies.get("iluUser");
    
    if (token && user) {
      try {
        return dispatch({
          type: IS_IN_SESSION,
          payload: JSON.parse(user)
        });
      } catch (error) {
        console.error('Error parsing user cookie:', error);
        // Si hay error al parsear, limpiar las cookies y cerrar sesión
        Cookies.remove("iluToken");
        Cookies.remove("iluUser");
        return dispatch({ type: ISNT_IN_SESSION });
      }
    } else {
      return dispatch({ type: ISNT_IN_SESSION });
    }
  };
}
